import * as React from 'react';
import { useEffect, useRef } from 'react';
import * as Highcharts from 'highcharts';
import GanttCharts from 'highcharts/highcharts-gantt'
import Highstock from 'highcharts/highstock'
import HC_more from "highcharts/highcharts-more";
import HighchartsReact from 'highcharts-react-official';
import { useIsMounted } from "usehooks-ts";
import { handleChartWheelScroll } from "@modules/dashboards/сharts/defaultCharts/linearChart/zoomingUtils";

// React supports function components as a simple way to write components that
// only contain a render method without any state (the App component in this
// example).

interface LinearChartProps {
    options: Highcharts.Options
    isStock?: boolean
    isGantt?: boolean
    isHcMore?:boolean
    zoomAxis?: 'xAxis' | 'yAxis'
    preventScrollWhenZoom?: boolean
}

GanttCharts.setOptions({
    lang: {
        months: [
            'Янв', 'Фев', 'Мар', 'Апр',
            'Май', 'Июн', 'Июл', 'Авг',
            'Сен', 'Окт', 'Ноя', 'Дек'
        ],
    }
});

[Highstock, Highcharts].forEach(i => i.setOptions({
    accessibility: {
        enabled: false
    },
    time: {
        useUTC: true
    },
    chart: {
        style: {
            fontFamily: 'PTRootUI',
            overflow: 'visible',
        }
    },
    lang: {
        shortMonths:[
            'Янв', 'Фев', 'Мар', 'Апр',
            'Май', 'Июн', 'Июл', 'Авг',
            'Сен', 'Окт', 'Ноя', 'Дек'
        ],
        months: [
            'Янв', 'Фев', 'Мар', 'Апр',
            'Май', 'Июн', 'Июл', 'Авг',
            'Сен', 'Окт', 'Ноя', 'Дек'
        ],
        resetZoomTitle: 'Сбросить масштаб',
        resetZoom: 'Сбросить масштаб',
    }
}));

const LinearChart = (props: HighchartsReact.Props | LinearChartProps) => {
    const {
        options,
        isGantt,
        isStock,
        zoomAxis,
        isHcMore,
        preventScrollWhenZoom
    } = props;

    let chart = Highcharts
    if(isStock) chart = Highstock
    if(isGantt) chart = GanttCharts

    if (isHcMore) {
        HC_more(chart)
    }

    const chartRef = useRef<HighchartsReact.RefObject>(null);

    const isMounted = useIsMounted();

    // Вешаем слушатель событий при зуме на колесико мыши
    useEffect(() => {
        if (isMounted() && chartRef.current?.container.current && zoomAxis) {
            const scrollHandler = handleChartWheelScroll(chartRef.current.chart, zoomAxis, preventScrollWhenZoom)
            // удаляем эвент с контейнера графика, чтобы не было проблемы с зумом при скроле мышкой
            Highcharts.removeEvent(chartRef.current.chart.container, 'wheel')

            chartRef.current.container.current.onwheel = (event) => {
                if (chartRef.current) scrollHandler(event);
            }
        }
    }, [isMounted, zoomAxis])

    return (
        <HighchartsReact
            ref={chartRef}
            highcharts={chart}
            constructorType={isGantt ? 'ganttChart' : 'chart'}
            containerProps={{ style: { height: "100%", width: "100%" } }}
            options={options}
            {...props}
        />
    )
}




export default LinearChart;